// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__32ttd","search":"Settings_search__1mdIW","filter":"Settings_filter__3J8Y0"};